import { render } from "./FridgeDetailsDrumPicker.vue?vue&type=template&id=3f410d80&ts=true"
import script from "./FridgeDetailsDrumPicker.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsDrumPicker.vue?vue&type=script&lang=ts"

import "./FridgeDetailsDrumPicker.vue?vue&type=style&index=0&id=3f410d80&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__